import React, { useState } from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";
import bootstrap from "../images/bootstrap.png";
import css from "../images/css.png";
import figma from "../images/figma.png";
import firebase from "../images/firebase.png";
import git from "../images/git.png";
import github from "../images/github.png";
import google from "../images/google.png";
import html from "../images/html.png";
import javascript from "../images/javascript.png";
import mongodb from "../images/mongodb.png";
import nodejs from "../images/nodejs.png";
import postgre from "../images/postgre.png";
import tailwind from "../images/tailwind.png";
import typescript from "../images/typescript.png";
import react from "../images/react.png";

const skills = [
  {
    id: "js",
    name: "JavaScript",
    logo: javascript,
    description:
      "I have a solid understanding of JavaScript basics, but I am still learning advanced concepts.",
  },
  {
    id: "html",
    name: "HTML",
    logo: html,
    description:
      "HTML is something I’m very comfortable with, I can build the structure of any web page without difficulty.",
  },
  {
    id: "css",
    name: "CSS",
    logo: css,
    description:
      "CSS is also something I’m familiar with, though I'm still working on mastering responsive design and animations.",
  },
  {
    id: "react",
    name: "React",
    logo: react,
    description:
      "I have been learning React, and I can build simple projects, but I am still working on mastering hooks and state management.",
  },
  {
    id: "node",
    name: "Node.js",
    logo: nodejs,
    description:
      "I am just starting with Node.js and backend development, but I’m excited to build server-side applications.",
  },
  {
    id: "typescript",
    name: "TypeScript",
    logo: typescript,
    description:
      "I’m learning TypeScript right now, focusing on the benefits of type safety and its integration with React.",
  },
  {
    id: "tailwind",
    name: "Tailwind CSS",
    logo: tailwind,
    description:
      "I’ve recently started using Tailwind CSS, and I find it fast for prototyping and building responsive layouts.",
  },
  {
    id: "bootstrap",
    name: "Bootstrap",
    logo: bootstrap,
    description:
      "Bootstrap is useful for building quick, responsive sites, and I have experience using it in multiple projects.",
  },
  {
    id: "mongodb",
    name: "MongoDB",
    logo: mongodb,
    description:
      "I’ve used MongoDB in small projects, and I’m learning more about its flexibility for storing data.",
  },
  {
    id: "postgresql",
    name: "PostgreSQL",
    logo: postgre,
    description:
      "I’m new to PostgreSQL, but I am learning about relational databases and their structure.",
  },
  {
    id: "git",
    name: "Git",
    logo: git,
    description:
      "Git is a crucial part of my workflow. I use it regularly to manage versions and collaborate on projects.",
  },
  {
    id: "github",
    name: "GitHub",
    logo: github,
    description:
      "I use GitHub to host repositories and collaborate with other developers on projects.",
  },
  {
    id: "firebase",
    name: "Firebase",
    logo: firebase,
    description:
      "I’ve experimented with Firebase for authentication and database management in web and mobile apps.",
  },
  {
    id: "figma",
    name: "Figma",
    logo: figma,
    description:
      "I use Figma for designing web interfaces and UI elements, although I’m still working on improving my design skills.",
  },
  {
    id: "googlecloud",
    name: "Google Cloud",
    logo: google,
    description:
      "I’ve started learning Google Cloud services and how they can be integrated into web applications.",
  },
];

function Skills() {
  const [selectedSkill, setSelectedSkill] = useState(null);

  const handleSkillClick = (skill) => {
    setSelectedSkill(skill);
  };

  const settings = {
    infinite: true,
    speed: 8000,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    variableWidth: true,
    centerMode: true,
    draggable: true,
  };

  return (
    <section className="min-h-screen bg-transparent text-white flex flex-col items-center justify-center snap-start px-4" style={{ paddingTop: "4rem" }}>
      {/* Section Title */}
      <motion.h2
        className="text-4xl md:text-6xl font-extrabold text-green text-center mb-12 relative inline-block"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
      >
        Technology Skills
        <span
          className="absolute inset-0 blur-2xl opacity-50 animate-glowPulse"
          style={{
            background: "radial-gradient(circle, #00ff00 0%, transparent 70%)",
          }}
        ></span>
      </motion.h2>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 w-full max-w-6xl">
        {skills.map((skill) => (
          <div
            key={skill.id}
            className="relative group cursor-pointer flex flex-col items-center p-4 bg-gray-900 rounded-xl shadow-lg hover:scale-105 transition-transform"
          >
            <img
              src={skill.logo}
              alt={skill.name}
              className="w-16 h-16 object-contain"
            />
            <h4 className="mt-2 text-sm font-semibold">{skill.name}</h4>

            {/* Description overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-80 text-white p-4 opacity-0 group-hover:opacity-100 flex items-center justify-center text-center rounded-xl transition-opacity">
              <p className="text-xs">{skill.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Skills;
